import { render, staticRenderFns } from "./SimuladoResultadoView.vue?vue&type=template&id=d54e1a46&scoped=true&"
import script from "./SimuladoResultadoView.vue?vue&type=script&lang=js&"
export * from "./SimuladoResultadoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54e1a46",
  null
  
)

export default component.exports